import { Component } from 'react';
import i18n from '@signavio/i18n';
import { Divider, LegacyButton as Button, Popover, Title2, defaultStyle } from '@signavio/ui';
import { loggerService } from '../services/logger';
import ErrorDetails from './ErrorDetails';
import { Hint } from './hints';
import { TextTile } from './tiles';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    const {
      logger = loggerService
    } = props;
    this.logger = logger;
    this.state = {
      error: null
    };
  }
  componentDidCatch(error, info) {
    this.logger.sendError(error, info);
    this.setState({
      error
    });
  }
  render() {
    const {
      children
    } = this.props;
    const {
      error
    } = this.state;
    if (error) {
      return this.renderError(error);
    }
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  renderError(error) {
    const {
      asTile,
      small,
      transparent,
      style
    } = this.props;
    if (asTile) {
      return /*#__PURE__*/_jsx(Popover, {
        popover: /*#__PURE__*/_jsx(ErrorDetails, {
          debug: true,
          children: /*#__PURE__*/_jsx("pre", {
            ...style('error'),
            children: `${error.name || 'Error'}: ${error.message}`
          })
        }),
        children: /*#__PURE__*/_jsx(TextTile, {
          small,
          transparent,
          children: /*#__PURE__*/_jsx(Hint, {
            danger: true,
            small: small,
            inline: true,
            children: i18n('Something went wrong')
          })
        })
      });
    }
    return /*#__PURE__*/_jsx(Hint, {
      danger: true,
      children: /*#__PURE__*/_jsxs("div", {
        ...style('content'),
        children: [/*#__PURE__*/_jsx(Title2, {
          children: i18n('Oops, something went wrong!')
        }), /*#__PURE__*/_jsx(ErrorDetails, {
          debug: true,
          children: /*#__PURE__*/_jsx("pre", {
            ...style('error'),
            children: `${error.name || 'Error'}: ${error.message}`
          })
        }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Button, {
          primary: true,
          icon: "refresh",
          onClick: () => window.location.reload(),
          children: i18n('Reload application')
        })]
      })
    });
  }
}
const enhance = defaultStyle({
  content: {
    fontStyle: 'normal'
  },
  error: {
    whiteSpace: 'pre-wrap'
  }
});
export default enhance(ErrorBoundary);